namespace TabAurous.OMS {
    export interface AccountLedgerRow {
        LedgerId?: number;
        PartyType?: string;
        PartyCode?: string;
        LedgerName?: string;
        AccountGroupId?: number;
        AccountGroupName?: string;
        Nature?: string;
        TermId?: number;
        MailingName?: string;
        BillbyBill?: boolean;
        IsDisabled?: boolean;
        DefaultTDSType?: string;
        AccountNo?: string;
        IFSCCode?: string;
        MICRCode?: string;
        Swift?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace AccountLedgerRow {
        export const idProperty = 'LedgerId';
        export const nameProperty = 'LedgerName';
        export const localTextPrefix = 'OMS.AccountLedger';
        export const lookupKey = 'AGLDGR';

        export function getLookup(): Q.Lookup<AccountLedgerRow> {
            return Q.getLookup<AccountLedgerRow>('AGLDGR');
        }
        export const deletePermission = 'Customer:Delete';
        export const insertPermission = 'Customer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Customer:Edit';

        export declare const enum Fields {
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            PartyCode = "PartyCode",
            LedgerName = "LedgerName",
            AccountGroupId = "AccountGroupId",
            AccountGroupName = "AccountGroupName",
            Nature = "Nature",
            TermId = "TermId",
            MailingName = "MailingName",
            BillbyBill = "BillbyBill",
            IsDisabled = "IsDisabled",
            DefaultTDSType = "DefaultTDSType",
            AccountNo = "AccountNo",
            IFSCCode = "IFSCCode",
            MICRCode = "MICRCode",
            Swift = "Swift",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
